// Module
var code = "<template> <p class=\"vui-u-text-responsive\"> Denne siden har som hensikt å inneholde all informasjon du skulle trenge før du deltar på LANet. </p> <p>En rask gjennomgang anbefales til alle deltakere.</p> </template> ";
// Exports
export default code;